import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import React from "react";
import {InputLabel} from "@material-ui/core";

export default (data, key) => {
    return (<Box key={key} style={{padding: '10px 0'}}>
            <InputLabel htmlFor={`${data.name}-${key}`}>
                {data.headerName}
            </InputLabel>
            <TextField
                margin="normal"
                type={'number'}
                disabled={data.disabled}
                fullWidth
                onChange={data.onCallback}
                error={data.error ? true : false}
                helperText={data.error}
                inputProps={data.inputProps || {}}
                id={`${data.name}-${key}`}
                name={data.name}
                autoFocus
                value={data.value}
            />
        </Box>)
}